<p-paginator
  #paginator
  [totalRecords]="totalRecords"
  [rowsPerPageOptions]="[]"
  [rows]="rows"
  (onPageChange)="onPageChange($event)"
>
</p-paginator>
